import { filterOptionNameResolver } from '../../configurator/components/FabricFacetFilters/filterNameResolver';
import { FabricFacetFiltersTranslation, TagsTranslations } from '../../localization/SiteTranslation';
import Tags from '../../shared/components/Tags/Tags';
import { FiltersSelectionState } from './FilterState';

interface SelectedFiltersProps {
  selection: FiltersSelectionState;
  translation: FabricFacetFiltersTranslation;
  className?: string;
}

const SelectedFilters = ({ className, selection, translation }: SelectedFiltersProps) => {
  return (
    <div className={className}>
      <Tags
        items={selection.properties}
        onItemClick={(item) => selection.deselect(item)}
        clear={() => selection.clear()}
        translation={{ clearResults: translation.clearAllFiltersButtonLabel }}
        renderTagItemText={(item) => filterOptionNameResolver(item, translation)}
      />
    </div>
  );
};

export default SelectedFilters;
